/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WaitlistRouteImport } from './routes/waitlist'
import { Route as VerifyRouteImport } from './routes/verify'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as StudyTrackerRouteImport } from './routes/study-tracker'
import { Route as RecruitmentRouteImport } from './routes/recruitment'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LoggedOutRouteImport } from './routes/logged-out'
import { Route as InstructionsRouteImport } from './routes/instructions'
import { Route as GetStartedRouteImport } from './routes/get-started'
import { Route as FormCompleteRouteImport } from './routes/form-complete'
import { Route as FormRouteImport } from './routes/form'
import { Route as ExportRouteImport } from './routes/export'
import { Route as EntriesRouteImport } from './routes/entries'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as FormIndexRouteImport } from './routes/form/index'
import { Route as FormOnDutyIntervalsRouteImport } from './routes/form/on-duty-intervals'
import { Route as FormNotesRouteImport } from './routes/form/notes'
import { Route as FormGlucoseIssueRouteImport } from './routes/form/glucose-issue'
import { Route as FormAtSeaIntervalsRouteImport } from './routes/form/at-sea-intervals'
import { Route as FormAtSeaAllDayRouteImport } from './routes/form/at-sea-all-day'
import { Route as FormAtSeaRouteImport } from './routes/form/at-sea'

const WaitlistRoute = WaitlistRouteImport.update({
  id: '/waitlist',
  path: '/waitlist',
  getParentRoute: () => rootRouteImport,
} as any)
const VerifyRoute = VerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => rootRouteImport,
} as any)
const UnsubscribeRoute = UnsubscribeRouteImport.update({
  id: '/unsubscribe',
  path: '/unsubscribe',
  getParentRoute: () => rootRouteImport,
} as any)
const StudyTrackerRoute = StudyTrackerRouteImport.update({
  id: '/study-tracker',
  path: '/study-tracker',
  getParentRoute: () => rootRouteImport,
} as any)
const RecruitmentRoute = RecruitmentRouteImport.update({
  id: '/recruitment',
  path: '/recruitment',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LoggedOutRoute = LoggedOutRouteImport.update({
  id: '/logged-out',
  path: '/logged-out',
  getParentRoute: () => rootRouteImport,
} as any)
const InstructionsRoute = InstructionsRouteImport.update({
  id: '/instructions',
  path: '/instructions',
  getParentRoute: () => rootRouteImport,
} as any)
const GetStartedRoute = GetStartedRouteImport.update({
  id: '/get-started',
  path: '/get-started',
  getParentRoute: () => rootRouteImport,
} as any)
const FormCompleteRoute = FormCompleteRouteImport.update({
  id: '/form-complete',
  path: '/form-complete',
  getParentRoute: () => rootRouteImport,
} as any)
const FormRoute = FormRouteImport.update({
  id: '/form',
  path: '/form',
  getParentRoute: () => rootRouteImport,
} as any)
const ExportRoute = ExportRouteImport.update({
  id: '/export',
  path: '/export',
  getParentRoute: () => rootRouteImport,
} as any)
const EntriesRoute = EntriesRouteImport.update({
  id: '/entries',
  path: '/entries',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const FormIndexRoute = FormIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => FormRoute,
} as any)
const FormOnDutyIntervalsRoute = FormOnDutyIntervalsRouteImport.update({
  id: '/on-duty-intervals',
  path: '/on-duty-intervals',
  getParentRoute: () => FormRoute,
} as any)
const FormNotesRoute = FormNotesRouteImport.update({
  id: '/notes',
  path: '/notes',
  getParentRoute: () => FormRoute,
} as any)
const FormGlucoseIssueRoute = FormGlucoseIssueRouteImport.update({
  id: '/glucose-issue',
  path: '/glucose-issue',
  getParentRoute: () => FormRoute,
} as any)
const FormAtSeaIntervalsRoute = FormAtSeaIntervalsRouteImport.update({
  id: '/at-sea-intervals',
  path: '/at-sea-intervals',
  getParentRoute: () => FormRoute,
} as any)
const FormAtSeaAllDayRoute = FormAtSeaAllDayRouteImport.update({
  id: '/at-sea-all-day',
  path: '/at-sea-all-day',
  getParentRoute: () => FormRoute,
} as any)
const FormAtSeaRoute = FormAtSeaRouteImport.update({
  id: '/at-sea',
  path: '/at-sea',
  getParentRoute: () => FormRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/entries': typeof EntriesRoute
  '/export': typeof ExportRoute
  '/form': typeof FormRouteWithChildren
  '/form-complete': typeof FormCompleteRoute
  '/get-started': typeof GetStartedRoute
  '/instructions': typeof InstructionsRoute
  '/logged-out': typeof LoggedOutRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/recruitment': typeof RecruitmentRoute
  '/study-tracker': typeof StudyTrackerRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/waitlist': typeof WaitlistRoute
  '/form/at-sea': typeof FormAtSeaRoute
  '/form/at-sea-all-day': typeof FormAtSeaAllDayRoute
  '/form/at-sea-intervals': typeof FormAtSeaIntervalsRoute
  '/form/glucose-issue': typeof FormGlucoseIssueRoute
  '/form/notes': typeof FormNotesRoute
  '/form/on-duty-intervals': typeof FormOnDutyIntervalsRoute
  '/form/': typeof FormIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/entries': typeof EntriesRoute
  '/export': typeof ExportRoute
  '/form-complete': typeof FormCompleteRoute
  '/get-started': typeof GetStartedRoute
  '/instructions': typeof InstructionsRoute
  '/logged-out': typeof LoggedOutRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/recruitment': typeof RecruitmentRoute
  '/study-tracker': typeof StudyTrackerRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/waitlist': typeof WaitlistRoute
  '/form/at-sea': typeof FormAtSeaRoute
  '/form/at-sea-all-day': typeof FormAtSeaAllDayRoute
  '/form/at-sea-intervals': typeof FormAtSeaIntervalsRoute
  '/form/glucose-issue': typeof FormGlucoseIssueRoute
  '/form/notes': typeof FormNotesRoute
  '/form/on-duty-intervals': typeof FormOnDutyIntervalsRoute
  '/form': typeof FormIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRoute
  '/entries': typeof EntriesRoute
  '/export': typeof ExportRoute
  '/form': typeof FormRouteWithChildren
  '/form-complete': typeof FormCompleteRoute
  '/get-started': typeof GetStartedRoute
  '/instructions': typeof InstructionsRoute
  '/logged-out': typeof LoggedOutRoute
  '/login': typeof LoginRoute
  '/profile': typeof ProfileRoute
  '/recruitment': typeof RecruitmentRoute
  '/study-tracker': typeof StudyTrackerRoute
  '/unsubscribe': typeof UnsubscribeRoute
  '/verify': typeof VerifyRoute
  '/waitlist': typeof WaitlistRoute
  '/form/at-sea': typeof FormAtSeaRoute
  '/form/at-sea-all-day': typeof FormAtSeaAllDayRoute
  '/form/at-sea-intervals': typeof FormAtSeaIntervalsRoute
  '/form/glucose-issue': typeof FormGlucoseIssueRoute
  '/form/notes': typeof FormNotesRoute
  '/form/on-duty-intervals': typeof FormOnDutyIntervalsRoute
  '/form/': typeof FormIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/entries'
    | '/export'
    | '/form'
    | '/form-complete'
    | '/get-started'
    | '/instructions'
    | '/logged-out'
    | '/login'
    | '/profile'
    | '/recruitment'
    | '/study-tracker'
    | '/unsubscribe'
    | '/verify'
    | '/waitlist'
    | '/form/at-sea'
    | '/form/at-sea-all-day'
    | '/form/at-sea-intervals'
    | '/form/glucose-issue'
    | '/form/notes'
    | '/form/on-duty-intervals'
    | '/form/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/admin'
    | '/entries'
    | '/export'
    | '/form-complete'
    | '/get-started'
    | '/instructions'
    | '/logged-out'
    | '/login'
    | '/profile'
    | '/recruitment'
    | '/study-tracker'
    | '/unsubscribe'
    | '/verify'
    | '/waitlist'
    | '/form/at-sea'
    | '/form/at-sea-all-day'
    | '/form/at-sea-intervals'
    | '/form/glucose-issue'
    | '/form/notes'
    | '/form/on-duty-intervals'
    | '/form'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/entries'
    | '/export'
    | '/form'
    | '/form-complete'
    | '/get-started'
    | '/instructions'
    | '/logged-out'
    | '/login'
    | '/profile'
    | '/recruitment'
    | '/study-tracker'
    | '/unsubscribe'
    | '/verify'
    | '/waitlist'
    | '/form/at-sea'
    | '/form/at-sea-all-day'
    | '/form/at-sea-intervals'
    | '/form/glucose-issue'
    | '/form/notes'
    | '/form/on-duty-intervals'
    | '/form/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRoute
  EntriesRoute: typeof EntriesRoute
  ExportRoute: typeof ExportRoute
  FormRoute: typeof FormRouteWithChildren
  FormCompleteRoute: typeof FormCompleteRoute
  GetStartedRoute: typeof GetStartedRoute
  InstructionsRoute: typeof InstructionsRoute
  LoggedOutRoute: typeof LoggedOutRoute
  LoginRoute: typeof LoginRoute
  ProfileRoute: typeof ProfileRoute
  RecruitmentRoute: typeof RecruitmentRoute
  StudyTrackerRoute: typeof StudyTrackerRoute
  UnsubscribeRoute: typeof UnsubscribeRoute
  VerifyRoute: typeof VerifyRoute
  WaitlistRoute: typeof WaitlistRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/waitlist': {
      id: '/waitlist'
      path: '/waitlist'
      fullPath: '/waitlist'
      preLoaderRoute: typeof WaitlistRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/verify': {
      id: '/verify'
      path: '/verify'
      fullPath: '/verify'
      preLoaderRoute: typeof VerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/unsubscribe': {
      id: '/unsubscribe'
      path: '/unsubscribe'
      fullPath: '/unsubscribe'
      preLoaderRoute: typeof UnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/study-tracker': {
      id: '/study-tracker'
      path: '/study-tracker'
      fullPath: '/study-tracker'
      preLoaderRoute: typeof StudyTrackerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/recruitment': {
      id: '/recruitment'
      path: '/recruitment'
      fullPath: '/recruitment'
      preLoaderRoute: typeof RecruitmentRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logged-out': {
      id: '/logged-out'
      path: '/logged-out'
      fullPath: '/logged-out'
      preLoaderRoute: typeof LoggedOutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/instructions': {
      id: '/instructions'
      path: '/instructions'
      fullPath: '/instructions'
      preLoaderRoute: typeof InstructionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/get-started': {
      id: '/get-started'
      path: '/get-started'
      fullPath: '/get-started'
      preLoaderRoute: typeof GetStartedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form-complete': {
      id: '/form-complete'
      path: '/form-complete'
      fullPath: '/form-complete'
      preLoaderRoute: typeof FormCompleteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form': {
      id: '/form'
      path: '/form'
      fullPath: '/form'
      preLoaderRoute: typeof FormRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/export': {
      id: '/export'
      path: '/export'
      fullPath: '/export'
      preLoaderRoute: typeof ExportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/entries': {
      id: '/entries'
      path: '/entries'
      fullPath: '/entries'
      preLoaderRoute: typeof EntriesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/form/': {
      id: '/form/'
      path: '/'
      fullPath: '/form/'
      preLoaderRoute: typeof FormIndexRouteImport
      parentRoute: typeof FormRoute
    }
    '/form/on-duty-intervals': {
      id: '/form/on-duty-intervals'
      path: '/on-duty-intervals'
      fullPath: '/form/on-duty-intervals'
      preLoaderRoute: typeof FormOnDutyIntervalsRouteImport
      parentRoute: typeof FormRoute
    }
    '/form/notes': {
      id: '/form/notes'
      path: '/notes'
      fullPath: '/form/notes'
      preLoaderRoute: typeof FormNotesRouteImport
      parentRoute: typeof FormRoute
    }
    '/form/glucose-issue': {
      id: '/form/glucose-issue'
      path: '/glucose-issue'
      fullPath: '/form/glucose-issue'
      preLoaderRoute: typeof FormGlucoseIssueRouteImport
      parentRoute: typeof FormRoute
    }
    '/form/at-sea-intervals': {
      id: '/form/at-sea-intervals'
      path: '/at-sea-intervals'
      fullPath: '/form/at-sea-intervals'
      preLoaderRoute: typeof FormAtSeaIntervalsRouteImport
      parentRoute: typeof FormRoute
    }
    '/form/at-sea-all-day': {
      id: '/form/at-sea-all-day'
      path: '/at-sea-all-day'
      fullPath: '/form/at-sea-all-day'
      preLoaderRoute: typeof FormAtSeaAllDayRouteImport
      parentRoute: typeof FormRoute
    }
    '/form/at-sea': {
      id: '/form/at-sea'
      path: '/at-sea'
      fullPath: '/form/at-sea'
      preLoaderRoute: typeof FormAtSeaRouteImport
      parentRoute: typeof FormRoute
    }
  }
}

interface FormRouteChildren {
  FormAtSeaRoute: typeof FormAtSeaRoute
  FormAtSeaAllDayRoute: typeof FormAtSeaAllDayRoute
  FormAtSeaIntervalsRoute: typeof FormAtSeaIntervalsRoute
  FormGlucoseIssueRoute: typeof FormGlucoseIssueRoute
  FormNotesRoute: typeof FormNotesRoute
  FormOnDutyIntervalsRoute: typeof FormOnDutyIntervalsRoute
  FormIndexRoute: typeof FormIndexRoute
}

const FormRouteChildren: FormRouteChildren = {
  FormAtSeaRoute: FormAtSeaRoute,
  FormAtSeaAllDayRoute: FormAtSeaAllDayRoute,
  FormAtSeaIntervalsRoute: FormAtSeaIntervalsRoute,
  FormGlucoseIssueRoute: FormGlucoseIssueRoute,
  FormNotesRoute: FormNotesRoute,
  FormOnDutyIntervalsRoute: FormOnDutyIntervalsRoute,
  FormIndexRoute: FormIndexRoute,
}

const FormRouteWithChildren = FormRoute._addFileChildren(FormRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRoute,
  EntriesRoute: EntriesRoute,
  ExportRoute: ExportRoute,
  FormRoute: FormRouteWithChildren,
  FormCompleteRoute: FormCompleteRoute,
  GetStartedRoute: GetStartedRoute,
  InstructionsRoute: InstructionsRoute,
  LoggedOutRoute: LoggedOutRoute,
  LoginRoute: LoginRoute,
  ProfileRoute: ProfileRoute,
  RecruitmentRoute: RecruitmentRoute,
  StudyTrackerRoute: StudyTrackerRoute,
  UnsubscribeRoute: UnsubscribeRoute,
  VerifyRoute: VerifyRoute,
  WaitlistRoute: WaitlistRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
